import { render, staticRenderFns } from "./TrademarkObjectionToUsYidkStatusForm.vue?vue&type=template&id=1e76c99a&"
import script from "./TrademarkObjectionToUsYidkStatusForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsYidkStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsYidkStatusForm.vue?vue&type=style&index=0&id=1e76c99a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports